export default "__VITE_ASSET__Bw_95QN5__"